export const UPDATE_REVIEW_DATA = 'UPDATE_REVIEW_DATA';
export const UPDATE_RATING_DATA = 'UPDATE_RATING_DATA';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_HAS_MORE = 'UPDATE_HAS_MORE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
